<template>
  <transition name="fade">
    <div class="level3-landingpage-container">
      <div class="lv3-title-text">Tambah {{ label }}</div>
      <div class="lv3-edit-form" style="overflow-y: auto !important">
        <div class="edit-form-wrapper">
          <div>
            Sistem Menajemen/Lingkup Audit
          </div>
          <input class="lv3-input-text" type="text" v-model="audit"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Organisasi Pihak Ketiga (Lembaga Penerbit Sertifikasi)</div>
          <input class="lv3-input-text" type="text" v-model="pihak_ketiga"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);" />
        </div>
        <div class="edit-form-wrapper">
          <div>Masa Berlaku</div>
          <input class="lv3-input-text" type="number" v-model="masa_berlaku" />
        </div>
        <div class="edit-form-wrapper">
          <div>Tanggal Efektif</div>
          <input class="lv3-input-text" type="date" v-model="tgl_efektif" />
        </div>
        <div class="edit-form-wrapper">
          <div>Tanggal Berakhir</div>
          <input class="lv3-input-text" type="date" v-model="tgl_berakhir" disabled />
        </div>
        <div class="edit-form-wrapper">
          <div>Sertifikat</div>
          <label class="btn btn-default btn-file">
            <i class="fas fa-upload"></i>
            <span class="all-column">{{
        sertifikat && sertifikat.fileName
          ? sertifikat.fileName
          : sertifikat && sertifikat.original_name
            ? sertifikat.original_name
            : 'Upload'
      }}</span>
            <input type="file" style="display: none;" @change="fileChangeHandler($event)" />
          </label>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="submitForm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
import { api_lp } from '../../services/config'
export default {
  props: [
    'label',
    'modelName',
    'isRequired',
    'mutationName',
    'arrayMutation',
    'storeName',
    'modalName',
  ],
  data() {
    return {
      document_id: null,
    }
  },
  computed: {
    audit: {
      get() {
        return this.$store.state[this.storeName]['manage_audit']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'manage_audit',
          value: newValue,
        })
      },
    },
    pihak_ketiga: {
      get() {
        return this.$store.state[this.storeName]['manage_pihak_ketiga']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'manage_pihak_ketiga',
          value: newValue,
        })
      },
    },
    masa_berlaku: {
      get() {
        return this.$store.state[this.storeName]['manage_masa_berlaku']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'manage_masa_berlaku',
          value: newValue,
        })
      },
    },
    tgl_efektif: {
      get() {
        return this.$store.state[this.storeName]['manage_tgl_efektif']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'manage_tgl_efektif',
          value: newValue,
        })
      },
    },
    tgl_berakhir: {
      get() {
        return this.$store.state[this.storeName]['manage_tgl_berakhir']
      },
      set(newValue) {
        let total = 0
        if (this.masa_berlaku && this.masa_berlaku != 0) {
          total = this.masa_berlaku
        }

        let newDate = moment(
          this.$store.state[this.storeName]['manage_tgl_efektif'],
          'MM-DD-YYYY'
        ).add(total, 'year')

        this.$store.commit(this.mutationName, {
          name: 'manage_tgl_berakhir',
          value: newDate,
        })
      },
    },
    sertifikat: {
      get() {
        let document = this.$store.state[this.storeName]['manage_sertifikat']
        if (document) {
          this.document_id = document.id
        }

        return this.$store.state[this.storeName]['manage_sertifikat']
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: 'manage_sertifikat',
          value: newValue,
        })
      },
    },
  },
  watch: {
    masa_berlaku: function (newValue) {
      if (moment(this.tgl_efektif).isValid) {
        let newDate = moment(this.tgl_efektif, 'YYYY-MM-DD')
          .add(newValue, 'year')
          .format('YYYY-MM-DD')

        this.$store.commit(this.mutationName, {
          name: 'manage_tgl_berakhir',
          value: newDate,
        })
      }
    },
    tgl_efektif: function (newValue) {
      let newDate = moment(newValue, 'YYYY-MM-DD')
        .add(this.masa_berlaku, 'year')
        .format('YYYY-MM-DD')

      this.$store.commit(this.mutationName, {
        name: 'manage_tgl_berakhir',
        value: newDate,
      })
    },
  },
  methods: {
    closeModal() {
      this.$store.commit(this.mutationName, {
        name: this.modalName,
        value: false,
      })
      this.$store.commit(this.mutationName, {
        name: 'manage_add',
        value: false,
      })
    },
    async submitForm() {
      try {
        const submitedData = {
          request_id: this.$store['state'][this.storeName]['request_id'],
          k3l_doc_id: this.document_id
            ? this.document_id
            : this.$get(
              this.$store,
              `state.${this.storeName}.manage_sertifikat.id`
            ),
          lingkup_audit: this.audit,
          third_party: this.pihak_ketiga,
          masa_berlaku: this.masa_berlaku,
          tgl_efektif: this.tgl_efektif,
          tgl_berakhir: this.tgl_berakhir,
        }

        let url = `${api_lp}/api/v1/vendor/sistem-manajement`
        if (!this.$store.state[this.storeName]['manage_add']) {
          url = `${api_lp}/api/v1/vendor/sistem-manajemen/${this.$store['state'][this.storeName]['manage_id']
            }`
        }

        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        const { data } = await axios({
          method: this.$store.state[this.storeName]['manage_add']
            ? 'POST'
            : 'PUT',
          url,
          data: submitedData,
        })

        if (data && data.status == 'success') {
          this.$store.commit(this.mutationName, {
            name: 'manage_audit',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'manage_pihak_ketiga',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'manage_masa_berlaku',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'manage_tgl_efektif',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'manage_tgl_berakhir',
            value: '',
          })
          this.$store.commit(this.mutationName, {
            name: 'manage_sertifikat',
            value: '',
          })
          await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
          await this.$store.commit(this.mutationName, {
            name: this.modelName,
            value: data.data,
          })
          await this.closeModal()
        }
      } catch (error) {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
      // let dataForm = {
      //   id: this.$store.state[this.storeName]['manage_index'] + 1,
      //   audit: this.$store.state[this.storeName]['manage_audit'],
      //   pihak_ketiga: this.$store.state[this.storeName]['manage_pihak_ketiga'],
      //   masa_berlaku: this.$store.state[this.storeName]['manage_masa_berlaku'],
      //   tgl_efektif: this.$store.state[this.storeName]['manage_tgl_efektif'],
      //   tgl_berakhir: this.$store.state[this.storeName]['manage_tgl_berakhir'],
      //   sertifikat: this.$store.state[this.storeName]['manage_sertifikat'],
      // }

      // if (this.$store.state[this.storeName]['manage_add']) {
      //   await this.$store.commit(this.arrayMutation, {
      //     name: this.modelName,
      //     value: dataForm,
      //     operation: 'add',
      //   })
      //   await this.$store.commit(this.mutationName, {
      //     name: this.modalName,
      //     value: false,
      //   })
      // } else if (this.$store.state[this.storeName]['manage_edit']) {
      //   dataForm.id = this.$store.state[this.storeName]['manage_id']
      //   await this.$store.commit(this.arrayMutation, {
      //     name: this.modelName,
      //     value: dataForm,
      //     operation: 'edit',
      //   })
      //   await this.$store.commit(this.mutationName, {
      //     name: this.modalName,
      //     value: false,
      //   })
      // }
    },
    fileChangeHandler(e) {
      let fileHandler = Array.from(e.target.files)
      let fileType = fileHandler[0].type
      let fileName = fileHandler[0].name

      fileHandler['file'] = fileHandler
      fileHandler['fileName'] = fileHandler[0].name

      // this.sertifikat = fileHandler
      if (
        fileType.search(/jpeg|jpg|pdf|xls|zip|rar/gi) >= 0 ||
        fileName.search(/.rar/gi) >= 0
      ) {
        this.uploadFile(fileHandler[0])
      } else {
        alert('Jenis File ini tidak dapat di upload')
      }
    },
    async uploadFile(file) {
      try {
        await this.$store.commit('modalStore/SET_GLOBAL_LOADING', true)

        const url = `${api_lp}/api/v1/vendor/k3l-dokument`

        let bodyFormData = new FormData()
        bodyFormData.append(
          'request_id',
          this.$store['state'][this.storeName]['request_id']
        )
        bodyFormData.append('m_k3l_doc_id', 3)
        bodyFormData.append('k3l_document_lampiran[]', file)
        bodyFormData.append(
          'doc_id',
          this.document_id ? this.document_id : null
        )

        const { data } = await axios({
          method: 'POST',
          url,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        if (data.status == 'success') {
          this.document_id = data.data.id
          this.sertifikat = data.data
          this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        this.sertifikat = null
        this.$store.commit('modalStore/SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
